var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCctv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005 26V28C30.0005 33.656 30.0005 36.486 31.7585 38.242C33.5145 40 36.3445 40 42.0005 40M41.3825 36V44M18.0005 21.66L16.9265 21.778C15.3185 21.958 14.5145 22.046 13.8745 21.978C10.7505 21.638 8.28654 18.868 8.01654 15.39C7.96054 14.678 8.05054 13.786 8.22854 12M27.3825 14H27.4025M34.0005 14H43.0005",
    stroke: "#3B3B58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49186 8.448C4.04786 6.654 3.82586 5.758 4.16386 5.09C4.27787 4.86329 4.43398 4.66035 4.62386 4.492C5.18586 4 6.09986 4 7.93386 4H33.1099C39.1239 4 43.9999 8.924 43.9999 15C43.9999 21.076 39.1239 26 33.1079 26H23.6099C21.9779 26 21.1619 26 20.4619 25.72C19.9213 25.503 19.4346 25.1706 19.0359 24.746C18.5179 24.192 18.2159 23.426 17.6099 21.898L16.5339 19.184C15.9139 17.614 15.6019 16.83 15.0279 16.248C14.4519 15.668 13.6759 15.354 12.1219 14.728L8.73786 13.36C7.28386 12.772 6.55786 12.48 6.01186 11.96C5.82065 11.7788 5.64782 11.5792 5.49586 11.364C5.06186 10.748 4.87186 9.982 4.49186 8.448Z",
    stroke: "#3B3B58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctv);
export default __webpack_public_path__ + "static/media/cctv.4c84716aeed8ea9c19fd2dc1056c4719.svg";
export { ForwardRef as ReactComponent };